<template>
  <div>
    <h6>
      {{ label ? label : 'Editor' }}
      <span class="float-right badge badge-pill badge-primary">{{ lang }}</span>
    </h6>
    <prism-editor
      class="fcc-code-editor"
      :class="removeBorder ? 'remove-border' : ''"
      :value="value"
      :highlight="highlighter"
      :tab-size="tabSize"
      :ignore-tab-key="ignoreTabKey"
      :insert-spaces="insertSpaces"
      :line-numbers="lineNumbers"
      :read-only="readOnly"
      @input="onInput"
      @keydown="onKeydown"
      @keyup="onKeyup"
      @click="onClick"
      @focus="onFocus"
      @blur="onBlur"
    />
  </div>
</template>

<script>
import { PrismEditor } from 'vue-prism-editor'
import { highlight, languages } from 'prismjs/components/prism-core' // import highlighting library
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-scss'
import 'prismjs/components/prism-clike' // Dependência do javascript
import 'prismjs/components/prism-javascript'

import 'vue-prism-editor/dist/prismeditor.min.css' // import the styles somewhere
import 'prismjs/themes/prism-solarizedlight.css' // import syntax highlighting styles
import './assets/fccCodeEditor.scss'

export default {
  components: {
    PrismEditor
  },
  props: {
    value: {
      type: String,
      required: true
    },
    // Possíveis linguagens: https://prismjs.com/#supported-languages
    // Markup, CSS, SCSS, JavaScript
    lang: {
      type: String,
      required: true
    },
    label: String,
    tabSize: {
      type: Number,
      default: 2
    },
    insertSpaces: {
      type: Boolean,
      default: true
    },
    ignoreTabKey: {
      type: Boolean,
      default: false
    },
    lineNumbers: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    removeBorder: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'keydown', 'keyup', 'click', 'focus', 'blur'],
  methods: {
    highlighter(code) {
      // languages.<supported-language>
      return highlight(code, languages[this.lang], this.lang)
    },
    onInput(code) {
      this.$emit('input', code)
    },
    onKeydown(event) {
      this.$emit('keydown', event)
    },
    onKeyup(event) {
      this.$emit('keyup', event)
    },
    onClick(event) {
      this.$emit('click', event)
    },
    onFocus(event) {
      this.$emit('focus', event)
    },
    onBlur(event) {
      this.$emit('blur', event)
    }
  }
}
</script>
